<div [formGroup]="form">
  <div class="section-container" id="cabecalho">
    <div class="section-title">
      <mat-icon>receipt_long</mat-icon>
      <span>Serviço Tomado</span>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número do Documento</mat-label>
          <input matInput formControlName="numeroNFSe" placeholder="Nº da NFS-e recebida" />
          @if (form.get('numeroNFSe')?.hasError('required') && form.get('numeroNFSe')?.touched) {
          <mat-error>Campo obrigatório</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Série</mat-label>
          <input matInput formControlName="serieDps" />
        </mat-form-field>
      </div>
      <div class="col-12 col-sm-6 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Status</mat-label>
          <mat-select formControlName="idStatusFiscalNFSeEntrada">
            @for (opcao of listaStatusFiscal; track opcao.id) {
            <mat-option [value]="opcao.id">{{ opcao.descricao }}</mat-option>
            }
          </mat-select>
          @if (form.get('idStatusFiscalNFSeEntrada')?.hasError('required') &&
          form.get('idStatusFiscalNFSeEntrada')?.touched) {
          <mat-error>Campo obrigatório</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Chave de Acesso</mat-label>
          <!-- Opcional: só existe quando a NFS-e foi emitida eletronicamente e o usuário tem o
               documento em mãos. Informada, identifica a nota de forma única dentro da empresa. -->
          <input matInput formControlName="chaveAcesso" maxlength="100" placeholder="Chave da NFS-e, se houver" />
          <mat-hint>Opcional</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data de Emissão</mat-label>
          <input matInput [matDatepicker]="pickerEmissao" formControlName="datetimeEmissaoDps" />
          <mat-datepicker-toggle matSuffix [for]="pickerEmissao"></mat-datepicker-toggle>
          <mat-datepicker #pickerEmissao></mat-datepicker>
          @if (form.get('datetimeEmissaoDps')?.hasError('required') && form.get('datetimeEmissaoDps')?.touched) {
          <mat-error>Campo obrigatório</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Data de Execução/Entrada</mat-label>
          <input matInput [matDatepicker]="pickerEntrada" formControlName="dataExecucaoEntrada" />
          <mat-datepicker-toggle matSuffix [for]="pickerEntrada"></mat-datepicker-toggle>
          <mat-datepicker #pickerEntrada></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>